const AuctionEntryEmpty = () => {
  return (
    <div className="flex-1 flex flex-col items-center justify-center gap-8">
      <div>
        <img src="/auction-empty-state.gif" className="h-80" />
      </div>

      <div>
        <p className="text-base font-bold text-center">
          Nenhuma proposta enviada ainda
        </p>
      </div>
    </div>
  );
}

export default AuctionEntryEmpty;
